export default "__VITE_ASSET__DDZBy23Q__"